import Alerts from 'lib/alerts';
import Log from 'lib/log';

import template from 'employer/templates/payroll/stepOne/Payroll.html';
import modal from 'helpers/modal';
import ListView from './EmployeeList.js';
import SlideView from './EmployeeSlides.js';
import loader from 'helpers/loader';
import tooltip from 'helpers/tooltip';
import localStorageUtil from 'helpers/localStorageUtil';
import moment from 'moment';
import {payrollStatus} from '../../../../new-models/payroll';

const log = Log('payroll-step-one');

module.exports = Backbone.View.extend({
    activeTab: null,

    events: {
        'click .js-cancel-button':           'cancel',
        'click .js-save-draft-button':       'saveDraft',
        'click .js-save-button':             'save',
        'click .show-warning': 'showMultiplePayrollError',
        'shown.bs.tab .payroll-toggle-view a[data-toggle="tab"]': 'switchTab'
    },

    initialize: function(options) {
        if (
            moment().year() >= 2026 ||
            (app.company.get('payrolls2025Restricted') && moment().year() >= 2025)
        ) {
            $('#payrolls-restricted-notification').css({display: 'block'});
        }

        this.tabViews  = [];
        this.activeTab = null;
        this.tainted   = false;
        this.options   = _.defaults(options || {}, {
            tab:                null,
            employees:          null,
            allEmployees:       null,
            payrollDetails:     null,
            payroll:            null,
            payrollItems:       null,
            lastPayroll:        null,
            lastPayrollDetails: null,
            pendingJobs:        false
        });

        this.options.payrollDetails.on('sync', this.renderTitle, this);
        this.model.on('running', this.showLayoutLoader, this);
        this.model.on('run-complete', this.runComplete, this);

        app.events.on('navigate', this.handleUnsavedChanges, this);
        app.events.on('hard-exit', this.hardExit, this);

        this.options.payrollDetails.on('change add remove', this.taint, this);

        this.render();
    },

    // FIXME this methods are almost exact copies of the ones found in
    // commons/Form because I needed to change as little as possible as this
    // is a hotfix. We need to merge these methods into a separate class or
    // mixin.
    handleUnsavedChanges: function(status) {
        log.info('Caught navigate event...');
        if (this.dirty()) {
            log.info('...and we have unsaved changes');

            status.unsaved = true;
            status.msg = `You have unsaved changes. Exiting this page will \
                result in the changes being discarded.`;
        } else {
            status.unsaved = false;
        }
    },

    dirty: function() {
        return this.options.payrollDetails.isNew() ?
            this.tainted :
            this.options.payrollDetails.dirty();
    },

    taint: function() {
        this.tainted = true;
    },

    hardExit: function() {
        app.events.off(null, null, this);
    },

    render: function() {
        this.$el.html(template({
            tab: (
                localStorageUtil.getItem('payrollStepOneTab')
            ),
            disableTabSwitch: (
                this.options.allEmployees.length === 0
            ),
            showButtons: (
                this.options.allEmployees.length > 0 &&
                !this.model.get('running') &&
                !this.options.pendingJobs
            ),
            isRunPayrollDisabled: this.isRunPayrollDisabled()
        }));

        if (this.options.allEmployees.length > 0) {
            this.tabViews.push(
                new SlideView({
                    el: this.$('.js-payroll-slide-view'),
                    employees: this.options.allEmployees,
                    payroll: this.model,
                    payrollDetails: this.options.payrollDetails,
                    lastPayroll: this.options.lastPayroll,
                    lastPayrollDetails: this.options.lastPayrollDetails,
                    pendingJobs: this.options.pendingJobs,
                    payrollItems: this.options.payrollItems
                })
            );
        }

        this.tabViews.push(
            new ListView({
                el: this.$('.js-payroll-list-view'),
                employees: this.options.employees,
                lastPayroll: this.options.lastPayroll,
                payroll: this.model,
                pendingJobs: this.options.pendingJobs,
                payrollDetails: this.options.payrollDetails,
                payrollItems: this.options.payrollItems,
                lastPayrollDetails: this.options.lastPayrollDetails,
                layoutView: this.options.layoutView
            })
        );

        tooltip.init(this);
        this.renderTitle();

        setTimeout(function() {
            this.activeTab = _.find(this.tabViews, function(view) {
                return view.$el.hasClass('active');
            });

            this.activeTab.activate();
        }.bind(this), 1);

        this.renderPendingJobMsg(
            this.options.pendingJobs ||
            this.model.get('running')
        );
    },

    renderPendingJobMsg: function(hasPendingJobs) {
        this.$('.js-payroll-in-progress').toggleClass(
            'hidden', !hasPendingJobs
        );
    },

    showLayoutLoader: function() {
        this.options.layoutView.showLoader(true);
    },

    runComplete: function() {
        this.options.layoutView.hideLoader();
        app.mainRouter.navigate('payroll/step/2', {trigger: true});
    },

    switchTab: function(ev) {
        var $tabButton = $(ev.currentTarget);

        this.activeTab  = _.find(this.tabViews, function(view) {
            return view.$el.hasClass('active');
        });

        this.$('a[data-toggle="tab"].btn-success')
            .toggleClass('btn-success')
            .toggleClass('btn-white');
        $tabButton.toggleClass('btn-success').toggleClass('btn-white');

        this.activeTab.activate();

        localStorageUtil.setItem(
            'payrollStepOneTab', this.activeTab.$el.data('tab-name')
        );
    },

    renderTitle: function() {
        const count = this.options.allEmployees.length;
        const text  = 'Running Payroll for ' + count + ' ' +
            ((count === 1) ? 'Employee' : 'Employees');
        this.$('.js-payroll-title').text(text);
    },

    cancel: function() {
        var self = this;
        var cancelled = function() {
            self.options.payrollDetails.reset([]);

            Alerts.show('success', {
                title: 'Payroll Reset!',
                text:  'Your Payroll has been reset.',
            });
            app.mainRouter.navigate('payroll', {trigger: true});
        };

        Alerts.show('dangerConfirm', {
            text: 'You will not be able to recover this payroll',
            confirmButtonText: 'Yes, Restart',
            loader: true,
            callback: confirmed => {
                if (!confirmed) {
                    return;
                }
                return (
                    this.model.isNew() ?
                        Promise.resolve() : this.model.destroy()
                )
                    .then(() => cancelled())
                    .catch(err => {Alerts.show('criticalError', err);});
            }
        });
    },

    saveDraft: function(ev) {
        ev.preventDefault();
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);

        (this.model.isNew() ? this.model.save() : this.model.fetch())
            .then(() => {
                if (
                    this.model.get('running') ||
                    this.options.pendingJobs ||
                    this.model.get('status') !== payrollStatus.INITIAL
                ) {
                    if (this.model.get('running') || this.model.get('status') === payrollStatus.RAN) {
                        Alerts.show('warning', {
                            title: 'Warning',
                            text: `Note :This payroll is already at step 2. Please go to \
                                Payroll History and click on Continue Payroll.`,
                            allowEscapeKey: false,
                            callback: () => {
                                app.mainRouter.navigate('payroll/history', {trigger: true});
                            }
                        });
                    }
                    Alerts.show('warning', {
                        title: 'Warning',
                        text: `Please note that your payroll has been \
                            modified. To view accurate calculations, \
                            please reload the page.`,
                        allowEscapeKey: false,
                        callback: () => window.location.reload()
                    });
                    return;
                }

                return this.model.fetchAllPayrollDetails().then(res => {
                    if (res) {
                        if (this.checkDuplicate(res)) {
                            Alerts.show('warning', {
                                title: 'Error',
                                text: `Adding same payroll item twice is not allowed.
                                       Reload page to see updates.`,
                                allowEscapeKey: false,
                            });
                        } else {
                            this.options.payrollDetails.setPayroll(this.model);
                            return this.options.payrollDetails.save();
                        }
                    }
                })
            })
            .then(() => this.activeTab.save ? this.activeTab.save() : Promise.resolve())
            .then(() => Backbone.history.loadUrl())
            .catch(err => {
                stopLoader();
                Alerts.show('error', err, {
                    callback: () => {
                        app.mainRouter.navigate('payroll/history', {trigger: true});
                    }
                });
            })
            .finally(() => stopLoader());
    },

    checkDuplicate: function(savedPayrollItems) {
        const payrollDetails = this.options.payrollDetails;
        const duplicatePayrollDetails = payrollDetails.filter(x => {
            return savedPayrollItems.some(y => {
                return (x.getPayrollItem().id === y.getPayrollItem().id
                && x.isNew() && y.get("employeeId") === x.get("employeeId") &&
                    x.get('affectsItemId') === y.get('affectsItemId'))
            })
        }
        )
        return (duplicatePayrollDetails.length > 0);
    },

    displayBillingNotice: function() {
        app.company.set('billingNoticeGiven', true);
        return app.company.save();
    },

    displayPreviousPayslipDataWarning: function(employees) {
        if (employees.length === 0) {
            return Promise.resolve();
        }

        // 20200819 for the employees to show up in the warning dialog,
        // the employee must 1. has no payslips 2. has 0 amount in YTD
        // amount/prev employment
        return Promise.all(employees.map(
            employee => employee.getHasPrevItemYearlyTotals(moment().year())
        ))
            .then(() => {
                const employeesToShow = employees
                    .filter(emp => !emp.hasPrevItemYearlyTotals);

                if (employeesToShow.length === 0) {
                    return Promise.resolve();
                }

                // jscs:disable
                const names = employeesToShow
                    .map(employee => employee.get('fullName'))
                    .sort()
                    .join(', ').replace(/(, )(?=[^,]*$)/, ' and ');

                return new Promise((resolve, reject) => {
                    Alerts.show('warningConfirm', {
                        title: 'Important note!',
                        text: `<p>You might be missing previous payslip data \
                        for the following employees that have joined your \
                        company this year:<br>${names}.</p><p>Not entering \
                        this data will affect their monthly PCB calculations \
                        and EA forms.</p>`,
                        showCloseButton:   true,
                        cancelButtonText:  'No, Continue',
                        confirmButtonText: 'Yes, Edit Now'
                    }).then(() => {
                        app.mainRouter.navigate(
                            `employee/${_(employees).first().id}/previousPayslips`,
                            {trigger: true}
                        );
                        reject();
                    }, () => resolve());
                });
            });
    },

    save: function(ev) {
        ev.preventDefault();

        if (
            this.model.get('running') ||
            this.options.pendingJobs
        ) {
            return;
        }

        let stopLoader = () => {};
        const $button = this.$(ev.currentTarget);
        $button.prop('disabled', true);
        return this.checkMultiplePayrollRun()
            .then(() => this.checkFirstTimeEmployees())
            .then(() => this.checkBillingNotice())
            .then(() => this.activeTab.confirmMissingEmployees())
            .then(includeAll => {
                stopLoader = loader.startFullScreen($button);
                return (this.model.isNew() ? this.model.save() : this.model.fetch())
                    .then(() => {
                        if (this.model.get('running') || this.model.get('status') !== payrollStatus.INITIAL) {
                            throw new Error(`Note :This payroll is already at step 2. Please go to Payroll History and click on Continue Payroll.`);
                        }
                        this.options.payrollDetails.setPayroll(this.model);
                        return this.options.payrollDetails.save();
                    })
                    .then(() => this.activeTab.save ?
                        this.activeTab.save() :
                        Promise.resolve()
                    )
                    .then(() => this.model.run(includeAll))
                    .catch(err => {
                        if (
                            /duplicated payroll run detected/.test(err.message)
                        ) {
                            Alerts.show(
                                'criticalError',
                                `You can only run 1 payroll for the same month.`
                            );
                        } else if (/Payroll Item already exist for payroll/.test(err.message)) {
                            Alerts.show('warning', {
                                text: err.message,
                                customClass: 'sweet-alert-error'
                            });
                        } else if (/This payroll is already at step 2/.test(err.message)) {
                            Alerts.show('warning', err.message, {
                                callback: () => {
                                    app.mainRouter.navigate('payroll/history', {trigger: true});
                                }
                            });
                        } else if (
                            err.messages &&
                            err.messages.length &&
                            /Company has migrated to new PayrollPanda version/.test(err.messages[0])
                        ) {
                            Alerts.show(
                                'criticalError',
                                err.messages[0]
                            );
                        } else {
                            Alerts.show('warning', {
                                title: 'Warning',
                                text: `Please note that your payroll has been \
                                    modified. To view accurate calculations, \
                                    please reload the page.`,
                                allowEscapeKey: false,
                                callback: () => window.location.reload()
                            });
                        }
                    });
            })
            .finally(() => {
                stopLoader();
                $button.prop('disabled', false);
            });
    },

    isRunPayrollDisabled() {
        return this.options.lastPayroll &&
            (
                moment(this.options.lastPayroll.get('submittedDate'))
                    .tz('Asia/Kuala_Lumpur')
                    .isSame(
                        Date.now(),
                        'day'
                    ) ||
                this.options.lastPayroll.isCurrentPeriod()
            ) &&
            !app.user.isAdmin();
    },

    checkMultiplePayrollRun() {
        if (app.user.isAdmin()) {
            return Promise.resolve();
        }

        if (this.isRunPayrollDisabled()) {
            this.showMultiplePayrollError();
            return Promise.reject();
        }

        return app.company.fetchCurrentPayroll()
            .then(unsubmittedPayroll => {
                if (
                    unsubmittedPayroll && (
                        this.model.isNew() ||
                        unsubmittedPayroll.get('objectId') !== this.model.get('objectId')
                    )
                ) {
                    this.showMultiplePayrollError();
                    return Promise.reject();
                }
                return Promise.resolve();
            });
    },

    checkFirstTimeEmployees() {
        const firstTimeEmployees = this.options.allEmployees.filter(
            employee => !employee.get('hasPayslips')
        );

        if (firstTimeEmployees.length) {
            return this.displayPreviousPayslipDataWarning(firstTimeEmployees);
        }

        return Promise.resolve(true);
    },

    checkBillingNotice() {
        const displayBillingNotice = (
            app.company.get('isBillable') &&
            !app.company.get('billingNoticeGiven') &&
            !app.company.get('mppAdminId') &&
            !app.subscription.get('skipInvoicing')
        );

        if (displayBillingNotice) {
            return this.displayBillingNotice();
        }

        return Promise.resolve(true);
    },

    remove: function() {
        this.options.payrollDetails.on(null, null, this);
        this.model.off(null, null, this);

        this.undelegateEvents();
        _.each(this.tabViews, function(view, i) {
            view.remove();
            delete this.tabViews[i];
        }.bind(this));
        this.tabViews = [];
    },

    showMultiplePayrollError: function() {
        const text = this.options.lastPayroll.isCurrentPeriod() ?
            `<p>You have already completed a payroll for the current \
            month. You cannot run a new one until the 16th of the month. \
            </p><p>If you would like to delete your last submitted \
            payroll, and run it again, please email us at \
            <a href="mailto:admin@payrollpanda.my" target="_blank">\
            admin@payrollpanda.my</a>.</p><p>Alternatively, use the chat \
            window at the bottom right corner of the app and we will \
            assist you.</p>` :
            `<p>Please note that you already completed a payroll today and\
            cannot move to step 2 until tomorrow. For assistance, please\
            contact us via the live chat window.`;
        return modal.warning({
            title: `Cannot run payroll yet!`,
            html: text,
            confirmButtonText: `View Payroll Status`,
            customClass: 'sweet-alert-success',
            callback:    function(isConfirm) {
                if (isConfirm) {
                    app.mainRouter.navigate('payroll/history', {trigger: true});
                }
            }
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepOne/Payroll.js